import { Auth, Hub } from "aws-amplify";
import { ReactNode, useEffect, useState } from "react";
import { TenantContext, TenantIdentity } from "./TenantContext";

interface TenantProviderProps {
  children: ReactNode;
}

const TenantProvider = ({ children }: TenantProviderProps) => {
  const [tenant, setTenant] = useState<TenantIdentity | null>(null);

  useEffect(() => {
    let sessionVersion = 0;

    const refreshTenant = () => {
      const requestVersion = ++sessionVersion;
      setTenant(null);

      Auth.currentSession()
        .then(session => {
          if (requestVersion !== sessionVersion) return;

          const claims = session?.getIdToken()?.payload;
          const tenantKey = claims?.["active_tenant"];
          setTenant(
            typeof tenantKey === "string" && tenantKey
              ? {
                  tenantKey,
                  makerFeaturesEnabled: claims?.["is_maker_tenant"] === "true"
                }
              : null
          );
        })
        .catch(() => {
          if (requestVersion === sessionVersion) setTenant(null);
        });
    };

    refreshTenant();

    const unsubscribe = Hub.listen("auth", ({ payload: { event } }) => {
      if (event === "signIn") refreshTenant();
      if (event === "signOut") {
        ++sessionVersion;
        setTenant(null);
      }
    });

    return () => {
      ++sessionVersion;
      unsubscribe();
    };
  }, []);

  return (
    <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
  );
};

export default TenantProvider;